import { render, staticRenderFns } from "./DistributorForm.vue?vue&type=template&id=0db4d6cd&scoped=true"
import script from "./DistributorForm.vue?vue&type=script&lang=ts"
export * from "./DistributorForm.vue?vue&type=script&lang=ts"
import style0 from "./DistributorForm.vue?vue&type=style&index=0&id=0db4d6cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db4d6cd",
  null
  
)

export default component.exports